import React from "react";
import {
  Button,
  message,
  Modal,
  Form,
  Checkbox,
  Input,
  Card
 
} from "antd";

import "./MedicalTest.scss";
import api from "utils/api";
import { CONSTANTS } from "utils/constant";
import SubmitButton from "../../Patient/SubmitButton";


 class PublishPrescriptionPopup extends React.Component {
    publish_confirm = React.createRef();
    constructor(props) {
    super(props);
    this.state = {
        isloading:true,
        is_save:false,
        buttonLoading:false
       
     
    };
    this.form = React.createRef();
  }

  
    componentDidMount = () => { 
       this.publishPrescription()
     }

    publishPrescription = () => {
     api. publish_prescription_list({app_id:this.props.app_id})
     .then((res) => {
          if (res.data?.status == 200) {
        this.setState({...res.data.data})
        let disable={
          disable_med_test:res.data.data.is_medical_test,
          disable_allopathy_ayur:res.data.data.is_allopathy_ayurveda,
          disable_yoga:res.data.data.is_yoga,
          disable_diet:res.data.data.is_diet

        }
        this.setState({...disable})
          }
          
      
     
      
        })}

        publishPrescriptionList=(data)=>{
            
            let publish_data={
              app_id: this.props?.app_id,
              prescription_mail: true,
              data: {
                  "is_allopathy_ayurveda": this.state?.is_allopathy_ayurveda|| false,
                  "is_diet": this.state.is_diet || false,
                  "is_yoga": this.state.is_yoga || false,
                  "is_medical_test": this.state.is_medical_test || false
              }
            
            }
            if(!Object.values(publish_data.data)?.includes(true)){
                message.error("Please select atleast one prescription type.", ErrorDuration)
            }else{
             this.setState({buttonLoading:true})
               this.props.publishPrescription(publish_data)   
               
           }
        }
 

        
  render() {
   
    return (
      <div className="publish-popup">
         <Modal  
               className="publish-popup"
              closable={false}
              open={this.props.open_publish_modal}
               title={<div className="confirm-publish-title">
               {CONSTANTS.PUBLISH_SELECT}
             </div>}
              footer={false }
          >
             <div className="publish-form" >              
               
                <Form 
                    name={"publish-form"} 
                    ref={this.publish_confirm}
                    onFinish={ this.publishPrescriptionList}   
                    labelCol={{ span: 8 }}  
                    labelAlign={"left"}    
                    colon={false}          
                    >
                {this.state?.disable_allopathy_ayur ?
                    <Form.Item
                    name={"is_allopathy_ayurveda"} 
                    >                  
                     <Checkbox checked={this.state.is_allopathy_ayurveda}    onChange={(e)=>this.setState({is_allopathy_ayurveda:e.target.checked})}  ><b>Allopathy/Ayurveda</b> {this.state?.is_allopathy_ayurveda?<p>will be published</p>:null}</Checkbox>
                    </Form.Item>:null}
                    {this.state.disable_yoga ? 
                    <Form.Item  name ={"is_yoga"}>
                    <Checkbox checked={this.state.is_yoga}  onChange={(e)=>this.setState({is_yoga:e.target.checked})}><b>Yoga</b>{this.state.is_yoga?
                    <p>will be published</p>:null}</Checkbox>
                    </Form.Item>:
                    null}
                    {this.state.disable_diet?
                    <Form.Item name={"is_diet"} >
                    <Checkbox checked={this.state.is_diet}  onChange={(e)=>this.setState({is_diet:e.target.checked})}><b>Diet</b>{this.state?.is_diet ? <p>will be published</p>:null}</Checkbox>
                    </Form.Item>:null}
                    {this.state.disable_med_test ? 
                    <Form.Item name={"is_medical_test"} >
                    <Checkbox checked={this.state.is_medical_test} onChange={(e)=>{this.setState({is_medical_test:e.target.checked})}}><b>Medical Test</b>{this.state.is_medical_test? <p>will be published</p>:null}</Checkbox>
                    </Form.Item>:null}
                
                </Form>
               <div style={{textAlign:"center",border:"1px solid lightgray",borderRadius:"10px"}}>
               <p>
                   The selected prescription types are to be published. Prescription
                   once published cannot be changed.
                </p>
               </div>

                <div className="submit-button-wrapper" >         
              <SubmitButton className={"publish-button"} onClick={(val) => this.publish_confirm.current.submit(val)} label={CONSTANTS.PUBLISH} loading={this.state.buttonLoading}/> 
                  <Button className={"cancel-btn"} style={{background:"#B42318"}} onClick={()=>this.props?.closePopup()}>
                Cancel
              </Button>
             
         </div>
                </div>
                </Modal>
         </div>
    )
  }
}


export default (PublishPrescriptionPopup); 